/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionGeneratorComponent = function (unit, config, data) {
    Merge2MissionUnitComponent.call(this, unit);
    this.config = config;
    this.left = (data && data.left) || config.pool.map((entry) => entry.amount);
};

Merge2MissionGeneratorComponent.prototype = Object.create(Merge2MissionUnitComponent.prototype);
Merge2MissionGeneratorComponent.prototype.constructor = Merge2MissionGeneratorComponent;

Merge2MissionGeneratorComponent.prototype.isMovable = function () {
    return true;
};

Merge2MissionGeneratorComponent.prototype.isMergeable = function () {
    return false;
};

Merge2MissionGeneratorComponent.prototype.getTotalCharges = function () {
    return this.config.pool.reduce((sum, entry) => sum + entry.amount, 0);
};

Merge2MissionGeneratorComponent.prototype.getChargesLeft = function () {
    return this.left.reduce((sum, amount) => sum + amount, 0);
};

Merge2MissionGeneratorComponent.prototype.canMine = function () {
    return this.getChargesLeft() > 0;
};

Merge2MissionGeneratorComponent.prototype.isDone = function () {
    return !this.canMine();
};

Merge2MissionGeneratorComponent.prototype.pickIndex = function () {
    let roll = Math.floor(Math.random() * this.getChargesLeft());

    for (let i = 0; i < this.left.length; i++) {
        roll -= this.left[i];
        if (roll < 0) {
            return i;
        }
    }

    return this.left.length - 1;
};

Merge2MissionGeneratorComponent.prototype.mine = function () {
    if (!this.canMine()) {
        return undefined;
    }

    const index = this.pickIndex();
    this.left[index]--;

    const entry = this.config.pool[index];

    return entry.reward ? { reward: entry.reward } : { drop: [{ code: entry.code, stage: entry.stage, amount: 1 }] };
};

Merge2MissionGeneratorComponent.prototype.getBecomes = function () {
    return this.config.becomes;
};

Merge2MissionGeneratorComponent.prototype.save = function (data) {
    data.left = this.left;
};
